import CryptoJS from "crypto-js";

// todo - initialize this properly
const ROLE = {
  ADMIN: 1,
  USER: 2
};

const SECRET_KEY = 'AnetengyumhajEnlamis';

// retrieves the user record and roles and stores them in the session
const storeUserSession = (user, session) => {
  const enc_user = CryptoJS.AES.encrypt(JSON.stringify(user), SECRET_KEY);
  session.set('session', enc_user.toString());
};

const getCurrentUser = (session) => {
  const enc_user = session.get('session');
  if (enc_user) {
    const bytes = CryptoJS.AES.decrypt(enc_user.toString(), SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } else {
    return {};
  }
};

const hasRole = (role, session) => {
  const user = getCurrentUser(session);
  if (user && user.roleId === role) {
    return true;
  }
  return false;
};

const hasAdminRole = (session) => {
  return hasRole(ROLE.ADMIN, session);
};

const hasUserRole = (session) => {
  return hasRole(ROLE.USER, session);
};

const hasClient = (clientId, session) => {
  const user = getCurrentUser(session);

  if (!user || !session) {
    return false;
  }

  user.clients.forEach(client => {
    if (client.id === clientId) {
      return true;
    }
  })

  return false;
};

const hasApiAccess = (session) => {
  const user = getCurrentUser(session);
  if (user && user.useApi) {
    return true;
  }
  return false;
};

export {
  storeUserSession,
  getCurrentUser,
  hasAdminRole,
  hasUserRole,
  hasClient,
  hasApiAccess
};


// WEBPACK FOOTER //
// ./src/services/usersession.js